export enum TextInputTypes {
    TEXT = "text",
    EMAIL = "email",
    PASSWORD = "password",
}

interface TextInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder: string;
    name: string;
    type?: TextInputTypes;
    autoComplete?: string;
    disabled?: boolean;
    hasError?: boolean;
    "aria-label": string;
    "data-testid"?: string;
}

/** Single-line text input, sized like InputWithActions (font-size L, XS vertical padding, 2px border, button radius). */
const TextInput = (props: TextInputProps) => {
    const borderClass = props.hasError ? "border-p6-red" : "border-p6-grey-light";

    return (
        <input
            data-testid={props["data-testid"]}
            type={props.type ?? TextInputTypes.TEXT}
            name={props.name}
            value={props.value}
            onChange={(e) => props.onChange(e.target.value)}
            placeholder={props.placeholder}
            autoComplete={props.autoComplete}
            disabled={props.disabled}
            aria-label={props["aria-label"]}
            aria-invalid={props.hasError || undefined}
            className={`w-full py-xs px-s rounded-button border-2 ${borderClass} bg-white text-l text-p6-grey-dark placeholder:text-p6-grey-mid focus-visible:outline-2 focus-visible:outline-p6-orange disabled:opacity-60`}
        />
    );
};

export default TextInput;
